import { useCallback } from 'react';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';

/**
 * S334: çekmecede açık olan satırın seçimi URL'de durur (`?cari=<id>`): tarayıcının ve telefonun
 * geri tuşu çekmeceyi kapatır, bağlantı paylaşılır. Yerlice `pages/Risk.tsx` içindeki `?firma=` kalıbı.
 *
 * KAPATMAK GEÇMİŞE KAYIT EKLEMEZ. Açmak bir kayıt ekler; kapatmak da ekleseydi Geri tuşu az önce
 * kapatılan çekmeceyi YENİDEN açardı. Çekmece bu sayfadan açıldıysa kapatmak = bir adım geri;
 * paylaşılan bağlantıyla gelindiyse (önceki kayıt başka bir sayfa) aynı kaydın yerine yazılır.
 */
export function useCekmeceSecimi(anahtar: string) {
  const [params, setParams] = useSearchParams();
  const navigate = useNavigate();
  const secili = params.get(anahtar) ?? '';
  const buradanAcildi = (useLocation().state as { cekmece?: string } | null)?.cekmece === anahtar;

  const ac = useCallback(
    (kimlik: string | number) => {
      setParams((p) => { p.set(anahtar, String(kimlik)); return p; }, { state: { cekmece: anahtar } });
    },
    [anahtar, setParams],
  );

  const kapat = useCallback(() => {
    if (buradanAcildi) navigate(-1);
    else setParams((p) => { p.delete(anahtar); return p; }, { replace: true });
  }, [anahtar, buradanAcildi, navigate, setParams]);

  return { secili, ac, kapat };
}
